import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Users2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import StaffWorkspace from "@/components/admin/staff-workspace/StaffWorkspace";
import { Badge } from "@/components/ui/badge";

export default function StaffWorkspacePage() {
  const { id } = useParams();
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get(`/staff/${id}`)
      .then(r => { if (!cancelled) setStaff(r.data); })
      .catch(e => { if (!cancelled) toast.error(formatApiError(e.response?.data?.detail)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [id]);

  if (loading) return <div className="p-6 text-sm text-ink-soft">Loading workspace…</div>;
  if (!staff) return <div className="p-6 text-sm text-ink-soft">Staff not found.</div>;

  return (
    <div className="space-y-6" data-testid="staff-workspace-page">
      <header className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <Link to="/admin/staff" className="overline flex items-center gap-1.5 hover:text-terracotta transition-colors" data-testid="workspace-back">
            <ArrowLeft className="h-3 w-3" strokeWidth={1.5} /> All Staff
          </Link>
          <div className="flex items-center gap-3 mt-2">
            <div className="w-12 h-12 rounded-full bg-forest text-bone flex items-center justify-center font-serif text-2xl">
              {staff.name?.slice(0, 1)?.toUpperCase()}
            </div>
            <div>
              <h1 className="font-serif text-3xl leading-tight">{staff.name}</h1>
              <div className="text-xs text-ink-soft flex items-center gap-2 mt-1">
                <Badge className="bg-bone/60 text-ink border-line text-[10px] uppercase">{staff.status}</Badge>
                <span>{staff.position} · {(staff.department || "").replace(/_/g, " ")}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="text-xs text-ink-soft max-w-md">
          <div className="flex items-center gap-1.5 mb-1"><Users2 className="h-3 w-3 text-terracotta" strokeWidth={1.5} /> Workspace</div>
          <p className="leading-relaxed">{staff.mission || "The Founder's operating environment for this digital employee."}</p>
        </div>
      </header>

      <StaffWorkspace staffId={staff.id} staffName={staff.position} compact={false} />
    </div>
  );
}
